import { Component, OnInit, ViewChild } from '@angular/core';
import { DxHtmlEditorComponent, DxHtmlEditorModule } from 'devextreme-angular';
import { Observable, Subject } from 'rxjs';
import { DxoToolbarModule, DxiItemModule, DxoMediaResizingModule } from 'devextreme-angular/ui/nested';
import { NgIf } from '@angular/common';

@Component({
    selector: 'al-link-edit-info-modal',
    templateUrl: './link-edit-info-modal.component.html',
    styleUrls: ['./link-edit-info-modal.component.scss'],
    standalone: true,
    imports: [
        NgIf,
        DxHtmlEditorModule,
        DxoToolbarModule,
        DxiItemModule,
        DxoMediaResizingModule,
    ],
})
export class LinkEditInfoModalComponent implements OnInit {
	@ViewChild(DxHtmlEditorComponent)
	editor: DxHtmlEditorComponent;

	public showDialog: boolean = false;
	title: string = 'no title given';
	originalContent: string;
	content: string;

	result$: Subject<string>;

	constructor() {}

	ngOnInit(): void {}

	public show(title: string = null, originalContent: string = null): Observable<string> {
		this.result$ = new Subject<string>();

		if (title !== null && title.length > 0) this.title = title;
		else this.title = 'no title given';
		if (originalContent !== null && originalContent.length > 0) this.originalContent = originalContent;
		else this.originalContent = '<h4>No content was given</h4>';
		this.content = this.originalContent;
		this.showDialog = true;

		return this.result$.asObservable();
	}

	public cancel(): void {
		this.result$.complete();
		this.showDialog = false;
	}

	public save(): void {
		this.result$.next(this.editor.value);
		this.result$.complete();
		this.showDialog = false;
	}
}
